const DEFAULT_PLACEHOLDER = {
    light: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mN88erDfwAJRwPDhElpxQAAAABJRU5ErkJggg==',
    dark: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNs79/RBwAF0QJeORWL3gAAAABJRU5ErkJggg==',
    transparent: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII='
};
export { DEFAULT_PLACEHOLDER };
